// This file was auto-generated by querybuilder/Apollo and should not be edited.

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RecommendedLocLandlord
// ====================================================

export interface RecommendedLocLandlord_recommendedLocLandlord {
  /**
   * The name of the receipient at the address.
   */
  name: string;
  /**
   * Usually the first line of the address, e.g. "150 Court Street"
   */
  primaryLine: string;
  /**
   * The city of the address, e.g. "Brooklyn".
   */
  city: string;
  /**
   * The two-letter state or territory for the address, e.g. "NY".
   */
  state: string;
  /**
   * The zip code of the address, e.g. "11201" or "94107-2282".
   */
  zipCode: string;
}

export interface RecommendedLocLandlord {
  /**
   * The recommended landlord address for Letter of Complaint for the currently logged-in user, if any.
   */
  recommendedLocLandlord: RecommendedLocLandlord_recommendedLocLandlord | null;
}


export const RecommendedLocLandlord = {
  // The following query was taken from RecommendedLocLandlord.graphql.
  graphQL: `query RecommendedLocLandlord {
    recommendedLocLandlord {
        name,
        primaryLine,
        city,
        state,
        zipCode
    }
}`,
  name: "RecommendedLocLandlord",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, ): Promise<RecommendedLocLandlord> {
    return fetchGraphQL(RecommendedLocLandlord.graphQL);
  },

};

export const fetchRecommendedLocLandlord = RecommendedLocLandlord.fetch;